import { Avatar } from "@mittwald/flow-remote-react-components";
import { ContextMenu, MenuItem } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import {
  IconUser,
  IconPassword,
  IconDelete,
} from "@mittwald/flow-remote-react-components";
import { ListItemView } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { ChangePasswordModal } from "./ChangePasswordModal";
import { DeleteUserModal } from "./DeleteUserModal";
import { User } from "../../openapi/types";
import { useOverlayController } from "@mittwald/flow-remote-react-components";
import { useListDirectoryProtections } from "../../hooks/useListDirectoryProtections";
import { AlertBadge } from "@mittwald/flow-remote-react-components";

export const UserListItem = (props: { user: User; projectId: string }) => {
  const { user } = props;

  const deleteModalController = useOverlayController("Modal", {
    reuseControllerFromContext: false,
  });

  const changePasswordModal = useOverlayController("Modal", {
    reuseControllerFromContext: false,
  });

  const directoryProtections = useListDirectoryProtections(props.projectId);

  const isUsed = directoryProtections.data.some((dp) =>
    dp.users.map((u) => u.username).includes(user.username),
  );

  return (
    <ListItemView>
      <Avatar>
        <IconUser />
      </Avatar>
      <Heading>
        {user.username}{" "}
        {!isUsed && (
          <AlertBadge status="warning">Nicht in Benutzung</AlertBadge>
        )}
      </Heading>
      <ContextMenu selectionMode="navigation">
        <MenuItem
          onAction={() => {
            changePasswordModal.open();
          }}
        >
          <IconPassword />
          <Text>Passwort ändern</Text>
        </MenuItem>
        <MenuItem
          onAction={() => {
            deleteModalController.open();
          }}
        >
          <IconDelete />
          <Text>Benutzer löschen</Text>
        </MenuItem>
      </ContextMenu>
      <ChangePasswordModal
        controller={changePasswordModal}
        projectId={props.projectId}
        username={user.username}
      />
      <DeleteUserModal
        controller={deleteModalController}
        username={user.username}
        projectId={props.projectId}
      />
    </ListItemView>
  );
};
